function multiSlider() {
	$(".multi-slider-section").each(function () {
		if ($(this).hasClass("slider_started")) return;
		$(this).addClass("slider_started");

		const id = $(this).attr("id");
		const box = $(this).find(".multi-slider");
		const directionSlider = box.data("direction") || false;
		const autoplay = box.data("autoplay") || false;
		const delay = box.data("delay") ? box.data("delay") * 1000 : 5000;

		let startX = 0;
		let endX = 0;

		const bulletsContainer = $(this).find("#bullets-bg")[0];

		class Slider {
			#current = 0;

			constructor(element, reverseDirection = false, bulletsContainer = null) {
				this.element = element;
				this.reverseDirection = reverseDirection;
				this.bulletsContainer = bulletsContainer;
				this.items = [...this.element.querySelectorAll(".slider__item")];
				this.itemsInner = this.items.map((item) =>
					item.querySelector(".slider__item-inner")
				);

				this.items.forEach((item, index) => {
					if (!item) return;
					if (index === this.current) {
						item.classList.add("slider__item--current");
						gsap.set(item, { opacity: 1 });
					} else {
						gsap.set(item, { opacity: 0 });
					}
				});

				this.itemsTotal = this.items.length;
				gsap.set([this.items, this.itemsInner], { "will-change": "transform" });

				if (this.element.classList.contains("slider--bg")) {
					this.initBullets();
				}

				this.initSwipeEvents();
			}

			initSwipeEvents() {
				this.element.addEventListener("touchstart", (event) => {
					if (event.target.closest(".multi-slider-slide__text")) return;
					startX = event.touches[0].clientX;
				});
				this.element.addEventListener("touchmove", (event) => {
					if (event.target.closest(".multi-slider-slide__text")) return;
					endX = event.touches[0].clientX;
				});
				this.element.addEventListener("touchend", () => {
					if (
						document.elementFromPoint(startX, 0)?.closest(".multi-slider-slide__text")
					)
						return;
					this.handleSwipe();
				});
			}

			handleSwipe() {
				if (startX - endX > 50) {
					this.next();
				} else if (endX - startX > 50) {
					this.prev();
				}
				startX = 0;
				endX = 0;
			}

			initBullets() {
				if (!this.bulletsContainer) return;

				this.bullets = this.items.map((_, i) => {
					const bullet = document.createElement("li");
					if (autoplay) bullet.classList.add("animate");

					const bulletInner = document.createElement("span");
					bullet.dataset.index = i;
					bullet.appendChild(bulletInner);
					bullet.addEventListener("click", () => {
						this.goTo(i);
						sliderFG.goTo(i);
					});

					this.bulletsContainer.appendChild(bullet);
					return bullet;
				});

				this.updateBullets();
			}

			updateBullets() {
				if (!this.bulletsContainer) return;

				this.bullets.forEach((bullet, i) => {
					bullet.classList.toggle("active", i === this.current);
				});
			}

			next() {
				if (this.items.length <= 1) return false;
				this.navigate(1);
			}

			prev() {
				if (this.items.length <= 1) return false;
				this.navigate(-1);
			}

			goTo(index) {
				if (
					this.items.length <= 1 ||
					this.isAnimating ||
					index === this.current
				)
					return false;

				const direction = index > this.current ? 1 : -1;
				this.navigate(direction, index);
			}

			get current() {
				return this.#current;
			}
			set current(value) {
				this.#current = value;
				if (this.element.classList.contains("slider--bg")) {
					this.updateBullets();
				}
			}

			navigate(direction, targetIndex = null) {
				if (this.isAnimating || this.items.length <= 1) return false;
				this.isAnimating = true;

				const previous = this.current;

				if (targetIndex !== null) {
					this.current = targetIndex;
				} else {
					this.current =
						direction === 1
							? this.current < this.itemsTotal - 1
								? ++this.current
								: 0
							: this.current > 0
							? --this.current
							: this.itemsTotal - 1;
				}

				const currentItem = this.items[previous];
				const currentInner = this.itemsInner[previous];
				const upcomingItem = this.items[this.current];
				const upcomingInner = this.itemsInner[this.current];

				const axis = directionSlider ? "x" : "y";
				const altAxis = axis === "x" ? "y" : "x";
				const percent = 100;
				const minorOffset = 30;
				const scaleProp = axis === "x" ? "scaleX" : "scaleY";

				const timeline = gsap.timeline({
					defaults: { duration: 1.1, ease: "power3.inOut" },
					onComplete: () => {
						currentItem.classList.remove("slider__item--current");
						upcomingItem.classList.add("slider__item--current");
						this.isAnimating = false;
					},
				});

				timeline
					.to(currentItem, {
						[`${axis}Percent`]: this.reverseDirection
							? direction * percent
							: -direction * percent,
						onComplete: () => gsap.set(currentItem, { opacity: 0 }),
					})
					.to(
						currentInner,
						{
							[`${axis}Percent`]: this.reverseDirection
								? -direction * minorOffset
								: direction * minorOffset,
							rotation: -direction * 1,
							[scaleProp]: 2.8,
						},
						0
					)
					.to(
						upcomingItem,
						{
							startAt: {
								opacity: 1,
								[`${axis}Percent`]: this.reverseDirection
									? -direction * 80
									: direction * 80,
							},
							[`${axis}Percent`]: 0,
						},
						0
					)
					.to(
						upcomingInner,
						{
							startAt: {
								[`${axis}Percent`]: this.reverseDirection
									? direction * minorOffset
									: -direction * minorOffset,
								[scaleProp]: 2.8,
								rotation: direction * 1,
							},
							[`${axis}Percent`]: 0,
							[scaleProp]: 1,
							rotation: 0,
						},
						0
					);
			}
		}

		const navigation = {
			next: $(this).find(".swiper-button-next"),
			prev: $(this).find(".swiper-button-prev"),
		};

		const sliderBG = new Slider(
			document.querySelector(`#${id} .slider--bg`),
			false,
			bulletsContainer
		);
		const sliderFG = new Slider(document.querySelector(`#${id} .slider--fg`));

		const syncSliders = (direction) => {
			if (direction > 0) {
				sliderBG.next();
				sliderFG.next();
			} else {
				sliderBG.prev();
				sliderFG.prev();
			}
		};

		sliderBG.handleSwipe = () => {
			if (startX - endX > 50) syncSliders(1);
			else if (endX - startX > 50) syncSliders(-1);
			startX = 0;
			endX = 0;
		};

		sliderFG.handleSwipe = sliderBG.handleSwipe;

		navigation.next.on("click", () => syncSliders(1));
		navigation.prev.on("click", () => syncSliders(-1));

		if (autoplay) {
			setInterval(() => syncSliders(1), delay);
		}

		// Cursor logic
		const slideshowSwiper = $(this).find(".container-wrapper")[0];
		if (!slideshowSwiper) return;

		const cursor = slideshowSwiper.querySelector(".cursor");
		const textBlock = slideshowSwiper.querySelector(".multi-slider-slide__text");
		const cursorNone = document.querySelector(".multi-slider-wrapper");

		const animateCursor = (e) => {
			const contentRect = slideshowSwiper.getBoundingClientRect();
			const x = e.clientX - contentRect.left - 21;
			const y = e.clientY - contentRect.top - 21;

			cursor?.animate(
				{ transform: `translate(${x}px, ${y}px)` },
				{ duration: 300, fill: "forwards" }
			);
		};

		const getCursorClass = (position, width) =>
			position < width / 2 ? "prev" : "next";

		slideshowSwiper.addEventListener("mousemove", (e) => {
			const cursorIcon = slideshowSwiper.querySelector('[data-id="cursor-icon"]');
			const swiperWidth = slideshowSwiper.clientWidth;

			if (
				!e.target.closest(".multi-slider-slide__text") &&
				!e.target.closest(".bullets") &&
				!e.target.closest(".marquee-tag")
			) {
				animateCursor(e);
				if (cursor) {
					cursor.dataset.type = getCursorClass(e.clientX, swiperWidth);
					if (cursorIcon) cursorIcon.className = cursor.dataset.type;
				}
			}
		});

		slideshowSwiper.addEventListener("mouseleave", () => {
			const cursorEl = document.querySelector(`#${id} .cursor`);
			if (cursorEl) cursorEl.classList.remove("active");
		});

		slideshowSwiper.addEventListener("click", (e) => {
			const swiperWidth = slideshowSwiper.clientWidth;
			const clickedPosition =
				e.clientX - slideshowSwiper.getBoundingClientRect().left;

			if (e.target.closest(".multi-slider-slide__text")) return;

			clickedPosition < swiperWidth / 2
				? navigation.prev.click()
				: navigation.next.click();
		});

		if (textBlock && cursorNone && cursor) {
			textBlock.addEventListener("mouseenter", () => {
				cursorNone.classList.add("text-hover");
				cursor.classList.add("hover-icon-none");
			});
			textBlock.addEventListener("mouseleave", () => {
				cursorNone.classList.remove("text-hover");
				cursor.classList.remove("hover-icon-none");
			});
		}
	});
}

// Run on DOM load
document.addEventListener("DOMContentLoaded", () => {
	setTimeout(() => {
		if (!document.querySelector(".multi-slider")) {
			console.warn("Multi-slider not found, skipping script.");
			return;
		}
		multiSlider();
	}, 500);
});

// Re-run on Shopify section load
document.addEventListener("shopify:section:load", (event) => {
	setTimeout(() => {
		if (!event.target.querySelector(".multi-slider")) {
			console.warn("Multi-slider not found in reloaded section, skipping.");
			return;
		}
		multiSlider();
	}, 300);
});
